import BasePopup from "../page/components/MiniGame/components/Popup";
import styled from "styled-components";
import btnClose from "../assets/images/whell-btn-close.png";
import { mediaQueryPoint, useMediaQuery } from "../utils/hooks";
import { DEVICE } from "../helper/const";
import { getData } from "../utils/localstorage";

export default function ModalAdvertisement({
  open,
  onCancel = () => {},
  dataAdvertisement,
}) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);

  const getHref = () => {
    const deviceActive = getData(DEVICE);
    let url = dataAdvertisement?.mobile_href;
    if (!deviceActive?.isWebView) {
      url = dataAdvertisement?.web_href;
    }

    return url;
  };

  const handleAction = () => {
    const url = isMobile
      ? dataAdvertisement?.mobile_href
      : dataAdvertisement?.web_href;
    // window.location.href = url;
    window.open(url);
    onCancel();
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    onCancel();
  };

  return (
    <div>
      <BasePopup
        className={`popup-invite position-relative`}
        // getContainer={true}
        isMaxWidth={true}
        open={open}
        onCancel={onCancel}
        width={"auto"}
      >
        <Div
          className="position-relative container-adver"
        // onClick={handleAction}
        >
          <div className="container-btn-close-whell-3">
            <img
              src={btnClose}
              alt=""
              // onClick={onCancel}
              onClick={(e) => handleCancel(e)}
              className="scale-hover-item btn-click-active"
            />
          </div>
          <a
            href={getHref()}
            style={{
              textDecoration: "underline",
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={dataAdvertisement.image}
              alt=""
              className="bg-popup-intro"
            />
          </a>
        </Div>
      </BasePopup>
    </div>
  );
}

const Div = styled.div`
  .container-btn-close-whell-3 {
    position: absolute;
    z-index: 3;
    top: 7px;
    right: 7px;
    cursor: pointer;
  }

  .container-adver {
    cursor: pointer;
  }

  .bg-popup-intro {
    max-height: 715px;
    max-width: 95vw;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
  }

  .position-relative {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }

  @media (min-width: 992px) {
    .container-adver {
      &:hover {
        scale: 1.005;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 413px) {
    .bg-popup-intro {
      max-width: 100%;
      /* min-height: 680px; */
    }
    .position-relative {
      position: relative;
      width: auto;
      margin: 0 auto;
    }
  }
`;
